/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import SLAContainer from './SLAContainer';

/**
 * Class that renders the SLA "invalid link ID" text within our SLAContainer component.
 */
class SLAInvalidLink extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <SLAContainer>
        <h3>This link is invalid or has expired.</h3>
        <p>Please contact your Honeywell Voice representative to resend the SLA information.</p>
      </SLAContainer>
    );
  }
}

export default SLAInvalidLink;
